// src/theme.js
import { createTheme } from "@mui/material/styles";

const AR_STACK =
  "'IBM Plex Sans Arabic','Noto Kufi Arabic','Tajawal',system-ui,-apple-system,Segoe UI,Arial,sans-serif";
const DE_STACK =
  "'Noto Sans','Inter',system-ui,-apple-system,'Segoe UI',Arial,sans-serif";
const EN_STACK = "'KrossNeueGrotesk', Arial, sans-serif";

const getFontStack = (language) => {
  const lang = language?.split("-")?.[0];
  if (lang === "ar") return AR_STACK;
  if (lang === "de") return DE_STACK;
  return EN_STACK;
};

export const makeTheme = (language, isArabic) => {
  const fontStack = getFontStack(language);

  return createTheme({
    direction: isArabic ? "rtl" : "ltr",
    typography: {
      fontFamily: fontStack,
      fontSize: isArabic ? 18 : 14,
      allVariants: {
        fontFamily: fontStack,
      },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            fontFamily: fontStack,
            WebkitFontSmoothing: "antialiased",
            MozOsxFontSmoothing: "grayscale",
            fontSize: isArabic ? "18px" : "16px",
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {},
          containedPrimary: {
            marginBottom: 16,
            backgroundColor: "#FFD600",
            color: "#111",
            borderRadius: "999px",
            padding: "12px 32px",
            fontWeight: 700,
            "&:hover": {
              backgroundColor: "#ffcc00",
            },
          },
          outlinedPrimary: {
            marginBottom: 16,
            borderColor: "#0088ffff",
            color: "#266795ff",
            padding: "12px 32px",
            fontWeight: 700,
            "&:hover": {
              borderColor: "#ffcc00",
              backgroundColor: "#91c5f3ff",
            },
          },
          selectedPrimary: {
            backgroundColor: "#123aaa",
            color: "#fff",
            "&:hover": {
              backgroundColor: "#0d2f7a",
            },
          },
          selectedSecondary: {
            marginBottom: 16,
            padding: "12px 32px",
            borderColor: "#FFD600",
            fontWeight: 700,
            backgroundColor: "#FFD600",
            color: "#111",
            "&:hover": {
              backgroundColor: "#ffcc00",
            },
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#FFD600",
            },
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            "&.MuiInputLabel-outlined": {
              fontSize: isArabic ? "16px" : "14px",
              fontWeight: isArabic ? 500 : 400,
              lineHeight: isArabic ? 1.2 : 1.4375,
            },
            "&.Mui-focused": {
              fontWeight: 500,
              color: "#111",
            },
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          input: {
            fontSize: isArabic ? "1rem" : "0.95rem",
          },
        },
      },
      MuiTooltip: {
        defaultProps: {
          enterTouchDelay: 0,
          leaveTouchDelay: 1500,
          disableFocusListener: true,
        },
      },
    },
  });
};
